import React from "react";

const EulaTermsText = (props) => {
  return (
    <>
      <h4>MU포인트 서비스 이용약관</h4>
      <h5>제1조 (목적) </h5>
      <p>
        이 약관은 모빌리전트 주식회사(이하 ‘회사’라 합니다)가 제공하는 서비스의
        이용과 관련하여 회사와 회원 사이의 권리, 의무, 책임 및 기타 제반 사항을
        규정함을 목적으로 합니다.
      </p>
      <h5>제2조 (용어의 정의) </h5>
      <ol>
        <li>
          ‘MU포인트 서비스’(이하 ‘서비스’라 합니다)란 회원이 MU포인트를 적립,
          사용하며, 제휴사 포인트와 교환 할 수 있도록 회사가 제공하는 서비스를
          말합니다.
        </li>
        <li>
          ‘MU포인트 앱’(이하 ‘앱’이라 합니다)이란 회사가 서비스 제공 목적으로
          회원에게 제공하는 전용 애플리케이션을 말합니다.
        </li>
        <li>
          ‘회원’이란 앱을 설치하여 회사에 가입신청 후, 이용약관 및 필요 정보를
          등록, 동의하고 회사가 제공하는 서비스를 이용하는 사람을 말합니다.
        </li>
        <li>‘MU포인트’란 회사가 발행 및 운영하는 포인트를 말합니다.</li>
        <li>
          ‘제휴사’란 서비스 제공을 위하여 회사와 관련 계약을 체결한 온/오프라인
          사업자를 말합니다.
        </li>
        <li>
          ‘제휴사 포인트’’란 제휴사가 발행 및 운영하는 포인트 또는 토큰을
          말합니다.
        </li>
        <li>
          본 약관에 사용되는 용어 중 본 조에서 정하지 않은 부분은 관계법령 및
          일반 관례에 따릅니다.
        </li>
      </ol>
      <h5>제3조 (약관의 효력 및 변경) </h5>
      <ol>
        <li>
          이 약관은 그 내용을 앱에 게시하거나 기타의 방법으로 회원에게 공지하고,
          이에 동의한 회원이 서비스에 가입함으로써 효력이 발생합니다.
        </li>
        <li>
          회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있으며, 회사가
          약관을 변경할 경우에는 특별한 사정이 없는 한 제1항과 같은 방법으로 그
          적용일자 7일 전부터 공지합니다. 다만 회원에게 불리한 약관의 변경이거나
          서비스와 관련하여 중대한 사항의 변경인 경우에는 적어도 그 적용일자
          30일 전부터 공지하며, 그렇지 않을 경우, 해당 변경사항은 공지 후 30일이
          경과한 날부터 변경효력이 발생합니다.
        </li>
        <li>
          회사가 위 제2항에 따라 변경 약관을 공지하면서, 회원에게 약관 변경 적용
          일까지 거부의사를 표시하지 아니할 경우 약관의 변경에 동의한 것으로
          간주합니다. 회원은 변경된 약관 사항에 동의하지 않으면 서비스 이용을
          중단하고 이용 계약을 해지할 수 있습니다.
        </li>
      </ol>
      <h5>제4조 (약관 외 준칙) </h5>
      <ol>
        <li>
          회사는 이 약관 외에 별도의 운영정책을 둘 수 있으며, 관련 법령, 회사가
          정한 개별 운영 정책 및 세부 이용 지침 등의 규정을 적용합니다.
        </li>
        <li>
          회사가 정한 개별 운영 정책 및 세부 이용 지침은 회원이 서비스
          이용과정에서 확인할 수 있으며, 개별 운영 정책 및 세부 이용 지침과
          관련하여 변경이 있는 경우 회사는 이를 앱에 게시합니다.
        </li>
      </ol>
      <h5>제5조 (회원가입 및 이용 계약의 체결) </h5>
      <ol>
        <li>
          회원은 회사가 정한 가입 양식에 따라 회원 정보를 기입한 후 이 약관 및
          개인정보 수집 및 이용에 동의, 본인확인 인증 절차를 마친 후 회원가입 및
          이용 계약 체결이 완료됩니다.
        </li>
        <li>
          회사는 다음 각 호에 해당하는 경우에는 이용 신청에 대하여 승낙하지 않을
          수 있습니다.
          <ol>
            <li>
              이전에 회원자격을 상실한 적이 있는 경우. 다만, 재가입 조건이
              충족되어 회사의 승낙을 얻은 경우에는 예외로 함
            </li>
            <li>이용 신청 시 입력 내용에 허위, 누락 및 오기가 있는 경우 </li>
            <li>
              이용 신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 본
              약관에서 규정한 제반 사항을 위반한 경우
            </li>
            <li>
              부정한 용도 또는 별개의 영업 목적으로 서비스를 이용하고자 하는
              경우
            </li>
            <li>이용 신청자의 나이가 만 14세 미만인 경우 </li>
          </ol>
        </li>
        <li>
          회사는 회원이 제공한 정보가 사실과 일치하는 지 여부를 확인하기 위하여
          법령에 의하여 허용된 범위에서 전문기관을 통한 실명확인 또는 본인인증을
          요청할 수 있으며, 이용자에게 증빙자료를 요구할수 있습니다.
        </li>
      </ol>
      <h5>제6조 (탈퇴 및 자격 상실) </h5>
      <ol>
        <li>
          회원은 앱에서 회사가 정한 방법 및 절차에 따르거나 직접 회사의 고객센터
          등에 통하여 서비스를 탈퇴 할 수 있습니다.
        </li>
        <li>
          회원이 서비스를 탈퇴하면 회원이 보유한 MU포인트는 모두 소멸 처리되며,
          복구가 불가능합니다.
        </li>
        <li>
          회원이 다시 서비스 가입을 하더라도 MU포인트는 복구 되지 않습니다.
        </li>
        <li>
          회사는 회원에게 다음 각 호의 어느 하나에 해당하는 사유가 있는 경우
          당해 회원에게 사전 통보 없이 서비스 이용 계약을 해지하거나 서비스
          이용을 제한할 수 있습니다.
          <ol>
            <li>가입 신청시에 허의 내용을 기재한 경우</li>
            <li>
              서비스 관련하여 회원이 부담하는 채무 기일까지 지급하지 않는 경우
            </li>
            <li>
              회원이 서비스의 운영을 방해하거나 이 약관 및 회사의 서비스 관련
              지침을 위반하는 경우
            </li>
            <li>해킹 및 사고가 발생한 경우나 명의 도용으로 의심되는 경우 </li>
            <li>국가기관이 관련 법령에 따라 서비스 제한을 요청하는 경우</li>
            <li>
              자금세탁, 불공정거래, 범죄행위 등에 관여하고 있거나, 관여하고
              있다고 합리적으로 의심되는 경우
            </li>
            <li>
              회원이 관계 법령, 감독규정, 감독기관의 지침 등을 위반한 경우
            </li>
            <li>서비스의 이용 목적을 벗어난 불합리한 용도로 이용한 경우 </li>
          </ol>
        </li>
        <li>
          회원은 서비스 이용계약 해지 또는 서비스 이용 제한에 관한 회사의 조치에
          대하여 이의가 있는 경우 회사가 정한 절차에 따라 이의 신청을 할 수
          있고, 회사는 회원의 이의 신청이 정당하다고 인정하는 경우, 즉시 서비스
          이용을 재개합니다.
        </li>
        <li>
          회사는 회원의 사유로 서비스 이용 계약을 해지하거나 제한하는 경우,
          회원이 이미 보유한 MU포인트는 동결되며 관련 법령 및 관할 정부기관 등의
          처분에 따라 처리되거나 처분이 필요 없는 경우 소멸됩니다.
        </li>
        <li>
          제1항에 의거 본인의 의지로 탈퇴한 회원의 경우 탈퇴일로부터 30일 이상이
          경과한 시점에 회사의 재가입 승낙을 얻어 회원에 다시 가입 할 수
          있습니다. 단, 탈퇴의 원인에 따라 재가입이 불가능할 수도 있습니다.
        </li>
      </ol>
      <h5>제7조 (서비스 제공 및 변경) </h5>
      <ul>
        <li>
          1. 회사는 다음 각호와 같은 서비스를 제공합니다.
          <ol>
            <li>MU포인트의 발행 및 적립 </li>
            <li>
              제휴사 포인트를 MU포인트로 교환 또는 MU포인트를 제휴사 포인트로
              교환
            </li>
            <li>제휴사가 운영하는 서비스에서 MU포인트의 사용 </li>
            <li>
              앱에서 상품 및 재화의 구입 또는 서비스 이용시 MU포인트의 사용
            </li>
            <li>이용내역 조회 </li>
            <li>기타 회사가 정하는 업무 등 </li>
          </ol>
        </li>
        <li>
          2. 회사는 서비스 화면을 통해 공지 후 제공 서비스를 변경할 수 있습니다.
        </li>
        <li>
          3. 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를
          제한하거나 중지할 수 있습니다.
          <ol>
            <li>
              서비스용 설비 또는 앱의 점검 또는 보수를 위하여 부득이한 경우
            </li>
            <li>
              회사의 영업양도, 분할, 합병 등의 따른 영업의 폐지, 주요 제휴사와의
              계약 만료, 경영상의 중대한 사유로 인해 서비스를 지속하기 어려운
              경우
            </li>
            <li>
              주요 설비, 네트워크의 장애, 정전 또는 이용량의 폭주 등으로
              정상적인 서비스 이용에 지장이 있는 경우
            </li>
            <li>
              관계 법령이나 감독규정, 감독기관의 지침 등에 의해 서비스 제공이
              곤란한 경우
            </li>
            <li>천재지변, 국가비상사태 등 불가항력적인 사유가 발생한 경우 </li>
            <li>
              기타 중대한 사유로 인하여 회사가 서비스를 제공할 수 없는 경우
            </li>
          </ol>
        </li>
        <li>
          4. 제3항에 의한 서비스 중단의 경우에는 회사가 앱 또는 회사 홈페이지에
          이를 공지합니다. 다만 회사가 통제할 수 없는 사유로 인한 서비스의
          중단(운영자의 고의, 과실이 없는 시스템 장애 등)으로 인하여 사전 통지가
          불가능한 경우에는 그러지 아니합니다.
        </li>
        <li>
          5. 회사는 정상적인 절차에 의한 것이거나 사전 공지된 서비스의 변경,
          중지, 중단 및 제한으로 발생하는 문제(서비스 중단 시간 동안의 제휴사
          포인트의 시세 하락 등)에 대해서는 어떠한 책임도 지지 않습니다.
        </li>
      </ul>

      <h5>제8조 (MU포인트의 발행 및 적립) </h5>
      <ul>
        <li>
          1. 회원은 다음 각 호의 경우 MU포인트를 적립 받을 수 있습니다.
          <ol>
            <li>앱의 활동 등에 따른 서비스 적립 정책에 해당하는 경우 </li>
            <li>제휴사에서 회원에게 발행 요청을 하는 경우 </li>
            <li>기타 회사가 운영하는 프로모션 및 이벤트에 참여할 경우 </li>
          </ol>
        </li>
        <li>
          MU포인트의 적립 시점 및 유효기간은 서비스 정책 및 이벤트 내용,
          제휴사의 요청에 따라 상이할 수 있으며, 부정한 방법으로 적립된
          MU포인트는 적립 취소 또는 강제 소멸 될 수 있습니다.
        </li>
      </ul>
      <h5>제9조 (MU포인트의 교환) </h5>
      <ul>
        <li>
          1. 회사는 다음 각호와 같이 교환 서비스를 제공합니다.
          <ol>
            <li>
              회원이 교환 서비스를 이용하고자 하는 경우 각 제휴사의 회원가입 및
              서비스 이용동의를 완료하여야 합니다.
            </li>
            <li>
              제휴사 포인트를 MU포인트로 교환 또는 MU포인트를 제휴사 포인트로
              교환시 교환 방법, 교환의 횟수, 교환의 한도, 교환 대상 등 구체적인
              내용은 해당 포인트를 발행하는 제휴사와 회사의 교환 정책에
              따릅니다.
            </li>
            <li>
              제휴사의 포인트와 MU포인트를 교환하는 기준가격(교환비율)은
              제휴사와 회사의 계약에 의해 정해지거나 미리 정해진 규칙에 따라
              일정한 범위내에서 실시간으로 변동할 수 있으며, 서비스 화면에
              표시됩니다
            </li>
            <li>
              제휴사 포인트를 MU포인트로 교환 또는 MU포인트를 제휴사 포인트로
              교환시 회사는 회원에게 수수료를 부과할 수 있으며, 서비스 화면에
              이를 표시합니다.
            </li>
            <li>
              교환된 제휴사 포인트 또는 교환된 MU포인트에 대해서는 유효기간이
              존재할 수 있으며, 유효기간이 경과한 경우 소멸됩니다.(제휴사별로
              포인트의 유효기간이 다를 수 있습니다).
            </li>
          </ol>
        </li>
        <li>
          2. 제휴사 포인트를 MU포인트로 교환 또는 MU포인트를 제휴사 포인트로
          교환 후에는 취소가 불가합니다.
        </li>
      </ul>
      <h5>제10조 (MU포인트의 사용) </h5>
      <ul>
        <li>
          1. 회사는 다음 각 호와 같이 MU포인트의 사용 서비스를 제공합니다.
          <ol>
            <li>
              제휴사가 운영하는 서비스에서 MU포인트의 사용할 수 있으며, 사용
              가치, 사용 방법, 사용 한도 등은 제휴사 운영 정책에 따라 다를 수
              있으며, 특정 제휴사에서는 사용이 불가 할 수 있습니다.
            </li>
            <li>
              앱에서 회사 및 제휴사가 제공하는 상품, 재화의 구입, 서비스 이용시
              MU포인트를 사용할 수 있으며, 특정 상품 및 서비스의 경우 사용이
              제한될 수 있습니다.
            </li>
            <li>
              특정 제휴사 또는 앱에서 상품 구매 및 서비스 이용시 MU포인트를
              사용할 경우, 사용 가치가 달라 지거나, 회원에게 수수료를 부과할 수
              있으며 서비스 화면에 이를 표시합니다.
            </li>
          </ol>
        </li>
        <li>
          2. MU포인트 사용 취소는 제휴사 또는 회사의 정책에 따라 상이하며, 특정
          제휴사의 경우 취소가 불가 할 수 있습니다. 취소 정책에 대한 내용은
          서비스 화면 또는 제휴사의 서비스에서 표기합니다.
        </li>
      </ul>
      <h5>제11조 (MU포인트의 한도) </h5>
      <ul>
        <li>
          1. 회사는 MU포인트의 보유, 교환, 사용 등의 한도를 정할 수 있으며, 이에
          대한 자세한 내용은 서비스에 게시합니다.
        </li>
        <li>
          2. 회사의 정책에 따라 위의 한도는 사전 고지 없이 변경될 수 있습니다.
        </li>
      </ul>
      <h5>제12조 (MU포인트의 환급, 양도, 매매 불가) </h5>
      <ul>
        <li>
          회원이 보유한 MU포인트는 환급, 양도, 매매가 불가하며, 회사의 허락없이
          양도, 매매할 경우 회원의 자격이 상실 될 수 있습니다.
        </li>
      </ul>
      <h5>제13조 (MU포인트의 유효기간 및 소멸) </h5>
      <ul>
        <li>
          1. 다음 각 호의 경우 MU포인트는 소멸됩니다.
          <ol>
            <li>MU포인트가 적립된 날로부터 3년이 경과하는 경우</li>
            <li>
              이벤트의 참여, 특정 활동에 대한 적립 또는 특정 제휴사의 포인트와
              교환된 MU포인트의 경우 유효기간 또는 소멸에 대한 내용이 별도로
              공지되며, 해당 유효기한이 경과하는 경우
            </li>
          </ol>
        </li>
        <li>
          2. 회원이 부당 또는 부정하게 MU포인트를 적립한 경우 회원은 MU포인트를
          사용할 수 없으며 회사는 이를 회수할 수 있습니다.
        </li>
      </ul>
      <h5>제14조 (회사의 의무) </h5>
      <ul>
        <li>
          1. 회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를
          제공하도록 노력합니다.
        </li>
        <li>
          2. 회사는 서비스 제공과 관련하여 알게 된 회원의 개인정보를 본인의 동의
          없이 제3자에게 누설, 배포하지 않습니다. 단, 관계 법령에 따라 적법한
          절차에 의한 경우에는 그러하지 않습니다.
        </li>
        <li>
          3. 회사는 서비스와 관련한 회원의 불만사항이 고객센터를 통하여 접수되면
          이를 신속하게 처리해야 하며, 신속한 처리가 어렵다면 그 사유와 처리
          일정을 서비스 화면에 게재하거나, 해당 회원에게 통지합니다.
        </li>
        <li>
          4. 회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우, 회사는
          그러한 손해가 회사의 귀책사유로 인해 발생한 경우에 한하여 책임을
          부담하며, 그 책임의 범위는 통상손해에 한정합니다.
        </li>
        <li>
          5. 회사는 정보통신망법 등 서비스의 운영, 유지와 관련 있는 법규를
          준수합니다.
        </li>
      </ul>
      <h5>제15조 (회원의 의무) </h5>
      <ul>
        <li>
          1. 회원은 본 약관의 규정, 관계법령, 이용안내 및 서비스상에 공지한
          주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사 업무
          또는 서비스에 방해되는 행위를 해서는 안 됩니다.
        </li>
        <li>
          2. 회원은 서비스 이용할 때 다음 각 호의 행위를 해서는 안 됩니다.
          <ol>
            <li>
              서비스 이용신청 또는 변경 시 허위 사실을 기재하거나, 제3자의
              정보를 도용, 부정하게 사용하는 행위, 휴대전화 명의자의 허락 없이
              실사용자가 인증 등을 수행하는 행위
            </li>
            <li>제3자의 인증정보를 등록하여 서비스를 이용하는 행위 </li>
            <li>
              회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이
              복제 또는 유통시키거나 상업적으로 이용하는 행위
            </li>
            <li>
              서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을
              유발시키는 컴퓨터 바이러스 감염 자료를 등록 또는 유포하는 행위
            </li>
            <li>회사와 기타 제3자의 저작권 등 지식재산권을 침해하는 행위 </li>
            <li>
              회사와 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
            </li>
            <li>
              서비스의 부당한 영향을 주는 방법으로 건전한 거래 질서를 교란하는
              행위
            </li>
            <li>다른 회원의 개인정보를 수집, 저장, 공개하는 행위 </li>
            <li>기타 회사가 게시한 정보를 변경하는 행위 </li>
            <li>기타 불법적이거나 부당한 행위 </li>
          </ol>
        </li>
        <li>
          3. 회원이 제2항에 명시된 행위를 한 경우, 회사는 서비스의 일부 또는
          전부에 대한 이용제한, 이용계약의 해지 등을 할 수 있으며, 회사에 손해가
          발생한 경우에는 손해배상 청구 등의 조치를 할 수 있습니다.
        </li>
        <li>
          4. 회사는 제3항에 정한 조치를 시행할 경우, 사전에 회원에게 서비스 내
          게재 또는 이메일, App Push 등으로 통보하며, 회원과 연락이 두절되거나
          긴급을 요하는 건과 같이 부득이한 경우, 선 조치 후 사후 통보할 수
          있습니다.
        </li>
        <li>
          5. 회원은 회사가 서비스를 안전하게 제공할 수 있도록 회사에 협조하여야
          하며, 회사가 회원의 약관 위반행위를 발견하여 회원에게 해당 위반행위에
          대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야 합니다
        </li>
        <li>
          6. 회원은 서비스 이용 신청 시 기재한 사항이 변경되었을 경우 회사가
          정한 방법에 의하여 이를 수정하여야 합니다. 회사는 회원이 변경 사항을
          적시에 수정하지 않음으로 인하여 발생하는 문제에 대해서는 어떠한 책임도
          지지 않습니다.
        </li>
      </ul>
      <h5>제16조 (회원의 인증정보 및 이용기기 관리에 대한 책임) </h5>
      <ul>
        <li>
          1. 회원은 인증정보 등의 관리에 대한 책임을 부담하며, 인증정보 등에
          대한 관리 소홀, 부정 사용에 의하여 발생하는 모든 책임은 회원 본인에게
          있습니다.
        </li>
        <li>
          2. 회원은 인증정보 등을 도난, 분실하거나 제3자가 사용하고 있음을
          인지한 경우에는 즉시 인증정보 등을 변경하는 등의 조치를 취하여야 하며,
          이와 동시에 회사에 통보하고, 회사의 안내가 있는 경우에는 그에 따라야
          합니다.
        </li>
        <li>
          3. 회원은 모바일 기기를 변경하거나, 분실, 도난당한 경우에는 앱 및
          고객센터를 통하여 MU포인트 및 제휴사의 포인트에 대한 도난, 유실되는
          것을 방지하기 위한 조치를 하여야 합니다.
        </li>
        <li>
          4. 회원은 다음 각 호에 해당하는 부정사용에 따른 모든 책임을
          부담합니다.
          <ol>
            <li>회원의 고의에 의한 부정사용 </li>
            <li>
              모바일 기기의 관리소홀, 대여, 양도, 담보제공, 제3자 보관 등으로
              인한 부정 사용
            </li>
            <li>비밀번호 등 인증정보 누설에 의한 부정 사용 </li>
            <li>회원의 가족, 동거인(사실상의 동거인 포함)에 의한 부정사용 </li>
          </ol>
        </li>
      </ul>
      <h5>제17조 (회원에 대한 통지) </h5>
      <ul>
        <li>
          회사는 회원에 대하여 통지를 하는 경우, 서비스 화면 또는 홈페이지에서의
          공지 또는 App Push, SMS 발송. 기타 통신수단 등의 방법으로 할 수
          있습니다.
        </li>
      </ul>
      <h5>제18조 (회원의 개인정보보호 등) </h5>
      <ul>
        <li>
          1. 회사는 관계 법령이 정하는 바에 따라 회원의 등록정보를 포함한 회원의
          개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관한
          사항은 관련 법령 및 회사가 정하는 개인정보처리방침에 정한 바에
          따릅니다.
        </li>
        <li>
          2. 회사는 서비스의 제공을 위하여 회원의 동의를 받아 회원의 개인정보를
          제휴사에 제공 또는 서비스 위탁운영사에게 제공할 수 있습니다.
        </li>
        <li>
          3. 회사는 수집된 개인정보의 취급 및 관리 등의 업무를 스스로 수행함을
          원칙으로 하나, 필요한 경우 위 업무의 일부 또는 전부를 회사가 선정한
          회사에 위탁할 수 있습니다.
        </li>
      </ul>
      <h5>제19조 (손해배상) </h5>
      <ul>
        <li>
          1. 회원이 이 약관의 규정을 위반하여 회사에 손해가 발생하는 경우, 이
          약관을 위반한 회원은 회사가 입은 모든 손해를 배상하여야 합니다.
        </li>
        <li>
          2. 회원이 서비스를 이용함에 있어 불법행위나 이 약관의 위반으로 인하여
          회사가 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를
          받는 경우, 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며,
          당해 회원은 그로 인하여 회사가 입은 모든 손해를 배상하여야 합니다.
        </li>
        <li>
          3. 회사가 서비스를 운영함에 있어 회사의 중대한 과실에 의하여 회원에게
          발생한 손해에 대해서는 회사는 회원에게 그로 인한 손해를 배상합니다.
          단, MU포인트 및 제휴사 포인트의 가치 변동으로 인한 자산가치의 증감은
          회원의 손실이 아닌 것으로 간주합니다.
        </li>
      </ul>
      <h5>제20조 (회사의 면책) </h5>
      <ul>
        <li>
          1. 회사는 천재지변 또는 이에 준하는 불가항력, 정보통신설비의 보수점검,
          교체 또는 고장, 통신의 두절 등으로 인하여 일시적 또는 종국적으로
          서비스를 제공할 수 없는 경우, 서비스 제공에 관한 책임이 면제됩니다.
        </li>
        <li>
          2. 회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지
          않습니다.
        </li>
        <li>
          3. 회사와 피연결회사(회사의 서비스와 링크, 제휴 등으로 연결된 시스템을
          운영하는 회사를 말함)는 독자적으로 운영되며, 회사는 피연결회사와 회원
          간에 이루어진 거래 또는 계약에 대하여 책임을 지지 않습니다.
        </li>
        <li>
          4. 회원 상호간의 거래로 인한 분쟁해결 등 필요한 사후처리는 거래
          당사자인 회원들이 직접 수행하여야 하고 회사는 이에 대하여 관여하지
          않으며 책임이 없는 것을 원칙으로 합니다. 단, 그 상황이 심각하여
          회원들이 중재를 요청할 경우 문제 해결에 관여할 수 있습니다.
        </li>
        <li>
          5. 회사는 단말기 자체의 결함이나 이동통신서비스의 장애 등으로 인하여
          서비스 이용이 불가한 경우 해당 통신사의 고객센터를 통하여 조치하여야
          하며, 이로 인하여 발생한 손해에 대하여 책임을 지지 않습니다.
        </li>
        <li>
          6. 회사는 회원이 개인정보를 타인에게 유출 또는 제공함으로써 발생하는
          피해나 회원의 과실 또는 부주의로 인하여 발생한 피해에 대하여 일체
          책임을 지지 않습니다.
        </li>
      </ul>
      <h5>제21조 (분쟁해결) </h5>
      <ul>
        <li>
          1. 회사는 회원이 제기하는 정당한 의견이나 불만을 반영하고 그 피해를
          보상 처리하기 위하여 피해 보상 처리 기구인 고객센터를 설치·운영합니다.
        </li>
        <li>
          2. 회사는 회원으로부터 제출되는 불만 사항 및 의견은 우선적으로 그
          사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그
          사유와 처리 일정을 즉시 통보해 드립니다.
        </li>
        <li>
          3. 회사와 회원간에 발생한 전자상거래 분쟁과 관련하여 회원의 피해 구제
          신청이 있는 경우에는 공정거래위원회 또는 시도지사가 의뢰하는
          분쟁조정기관의 조정에 따를 수 있습니다.
        </li>
      </ul>
      <h5>제22조 (관할법원) </h5>
      <ul>
        <li>
          1. 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우,
          회사와 회원은 분쟁의 해결을 위해 성실히 협의합니다.
        </li>
        <li>
          2. 제1항의 협의를 통해서도 분쟁이 해결되지 않는 경우, 양 당사자는
          민사소송법 상의 관할법원으로 정하여 해결합니다.
        </li>
      </ul>
      <p>
        <br />
        <br />
        &lt;부칙 &gt;
        <br />
        1.     이 약관은 2024년 04월 15일부터 시행됩니다.
      </p>
    </>
  );
};

export default EulaTermsText;
